export default "__VITE_ASSET__0545204f__"